import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import CancelButton from 'components/buttons/CancelButton'
import HHBaseDialog from 'components/common/HHBaseDialog'
import HHDialogTitle from 'components/common/HHDialogTitle'
import HHDialogActions from 'components/common/HHDialogActions'
import SaveButton from 'components/buttons/SaveButton'
import T from 'T'

const DeleteInvoiceConfirmation = ({ isOpen = false, isLoading = false, invoices = [], onDelete, onClose }) => {
  return (
    <HHBaseDialog open={isOpen} onClose={onClose} maxWidth="xl">
      <HHDialogTitle title={T.DELETE_CONFIRMATION} onClose={onClose} />
      <DialogContent>
        <DialogContentText>
          {invoices.length === 1 && (
            <Typography variant="h5" color="textPrimary" fontWeight={400}>
              {`${T.ARE_YOU_SURE_DELETE_INVOICE} `}
              <Typography variant="h5" fontWeight={400} color="primary" display="inline">
                {invoices[0]}
              </Typography>
              {`?`}
            </Typography>
          )}

          {invoices.length > 1 && (
            <>
              <Typography variant="h5" color="textPrimary" fontWeight={400}>
                {T.ARE_YOU_SURE_DELETE_INVOICES}
              </Typography>

              <Typography variant="h5" color="primary" fontWeight={400}>
                {invoices.join(', ')}
              </Typography>
            </>
          )}

          <Typography variant="h5" color="textPrimary" fontWeight={400}>
            {T.ACTION_CANNOT_BE_REVERSED}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <HHDialogActions>
        <CancelButton onClick={onClose} />
        <SaveButton loading={isLoading} color="error" label={T.YES_DELETE} onClick={onDelete} />
      </HHDialogActions>
    </HHBaseDialog>
  )
}

DeleteInvoiceConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  invoices: PropTypes.array,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default DeleteInvoiceConfirmation
